import React from "react";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "./ui/hover-card";
import { Info } from "lucide-react";

export default function EduTooltip({ term, children, definition }) {
  return (
    <HoverCard openDelay={150}>
      <HoverCardTrigger asChild>
        <span
          className="inline-flex items-center gap-1 cursor-help border-b border-dashed border-[#547A8F]/40 hover:border-[#547A8F] transition-soft"
          data-testid={`edu-tooltip-${term?.toLowerCase()}`}
        >
          {children}
          <Info className="w-3 h-3 text-[#547A8F]" strokeWidth={2} />
        </span>
      </HoverCardTrigger>
      <HoverCardContent className="w-72 bg-white/95 backdrop-blur-md border-[#EAE6E1] rounded-xl">
        <div className="flex items-start gap-2">
          <div className="w-1 h-full bg-[#547A8F] rounded-full" />
          <div className="space-y-1.5">
            <div className="text-[10px] uppercase tracking-[0.2em] font-semibold text-[#547A8F]">
              {term}
            </div>
            <p className="text-sm text-[#2A2F2B] leading-relaxed">{definition}</p>
          </div>
        </div>
      </HoverCardContent>
    </HoverCard>
  );
}
